<h3 class="title-divider-suche">{{ heading | translate }}</h3>
<ng-form>
  <fieldset>
    @if (mitRegion && model && model.mRegion?.access !== "DEACTIVATED") {
      <cap-form-row class="region">
        <cap-form-control column-classes="col-md-2,col-md-2" labelKey="Region">
          <cap-regionen
            (ngModelChange)="model && (model.region = $event)"
            [hasfocus]="false"
            [ngModel]="model && model.region"
            [searchMode]="searchMode"
            id="region"
            name="grundbuchamt.region"></cap-regionen>
          <button (click)="emptyRegionSearch()" class="btn btn-white" tabindex="-1" type="button">
            <span class="fas fa-times"></span>
          </button>
        </cap-form-control>
      </cap-form-row>
    }

    <cap-form-row column-classes="col-md-1,col-md-1">
      <cap-form-control column-classes="col-md-2,col-md-2" invalidKey="EingabeGemeindeErforderlich" labelKey="Gemeinde">
        <cap-gb-gemeinde
          (blur)="onTouched()"
          (ngModelChange)="model && (model.gbGemeindeId = $event)"
          [hasfocus]="hasfocus"
          [ngModel]="model && model.gbGemeindeId"
          [nurGueltige]="nurGueltige"
          [searchMode]="searchMode"
          class="typeahead-holder"
          name="grundstueckNummer.gbGemeindeId"></cap-gb-gemeinde>
        <button (click)="emptyGemeindeSearch()" class="btn btn-white" tabindex="-1" type="button">
          <span class="fas fa-times"></span>
        </button>
      </cap-form-control>
      <cap-form-control invalidKey="EingabeMussValideNummerSein" labelKey="Nummer">
        <input
          (blur)="onTouched()"
          (ngModelChange)="model && (model.nummer = processUniqueNummer($event))"
          [ngModel]="model && model.nummer"
          name="grundstueckNummer.nummer"
          size="6"
          type="text" />
      </cap-form-control>
      <cap-form-control
        *appPermission="model && model.mNummerZusatz"
        [labelKey]="indexTitle"
        column-classes="col-md-1, col col-md-1 input-series"
        invalidKey="EingabeMussValideNummerSein">
        <input
          (blur)="onTouched()"
          (ngModelChange)="model && (model.nummerZusatz = $event)"
          [ngClass]="index1Field"
          [ngModel]="model && model.nummerZusatz"
          name="grundstueckNummer.nummerZusatz"
          size="6"
          type="text" />
      </cap-form-control>
      <cap-form-control
        *appPermission="model && model.mNummer3"
        column-classes="px-0, col col-md-1 input-series"
        invalidKey="EingabeMussValideNummerSein">
        <input
          (blur)="onTouched()"
          (ngModelChange)="model && (model.nummer3 = $event)"
          [ngClass]="index2Field"
          [ngModel]="model && model.nummer3"
          name="grundstueckNummer.nummer3"
          size="6"
          type="text" />
      </cap-form-control>
      <cap-form-control
        *appPermission="model && model.mNummer4"
        column-classes="px-0, col col-md-1 input-series"
        invalidKey="EingabeMussValideNummerSein">
        <input
          (blur)="onTouched()"
          (ngModelChange)="model && (model.nummer4 = $event)"
          [ngModel]="model && model.nummer4"
          class="index-last"
          name="grundstueckNummer.nummer4"
          size="6"
          type="text" />
      </cap-form-control>
    </cap-form-row>
  </fieldset>
</ng-form>
